// Switch rows can be created before the heating system is known. SSR zero must
// therefore be allowed here so a gas-only (tgs) site can create its rows and
// choose tgs; confirm-time validation later rejects zero SSR for other systems.
export const areSwitchRowCountsUsable = ({
  numOfUOS,
  numOfSSR,
  numSwitches,
}) => {
  const uosCount = Number(numOfUOS);
  const ssrCount = Number(numOfSSR);
  const switchCount = Number(numSwitches);

  return (
    Number.isInteger(uosCount) &&
    uosCount > 0 &&
    Number.isInteger(ssrCount) &&
    ssrCount >= 0 &&
    Number.isInteger(switchCount) &&
    switchCount > 0
  );
};
